<template>
    <div class="card mt-3">
        <div class="card-body">
            <h5 class="card-title">FTP Details</h5>
            <ftp-server-form
                v-for="server in serverData.ftp.serverArr"
                :key="server.serverId"
                :server="server"
                @serverRemoved="removeServer($event)"></ftp-server-form>
            <button
                class="btn btn-sm float-right mt-3"
                @click="addServer"
                :disabled="serverData.ftp.serverArr.length >= 10 ? true : false">Add Server</button>
        </div>
    </div>
</template>

<script>
import FtpServerForm from './FtpServerForm.vue'

export default {
    components: {
        'ftp-server-form': FtpServerForm
    },
    props: ['serverData'],
    methods: {
        addServer() {
            this.$emit('serverAdded', 'ftp')
        },
        removeServer($event) {
            this.$emit('serverRemoved', {
                serverType: 'ftp',
                serverId: $event.serverId
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/server-forms/FtpDetails.vue